import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Col, Container, Row, Card, CardBody } from 'reactstrap';
import { Link } from 'react-router-dom';
import EditBannerForm from './components/EditBannerForm';

const EditBanner = ({ organization }) => (
    <Container className="dashboard">
        <Row>
            <Col md={12}>
                <h3 className="page-title">Banner Status</h3>
                <h3 className="page-subhead subhead"><Link className="" to="/">Home</Link> / <Link className="" to="/banner-status">Banner Status</Link> / Edit Banner</h3>
            </Col>
        </Row>
        <Row>
            <Col md={12}>
                <Card>
                    <CardBody style={{ display: 'flex' }}>
                        <EditBannerForm organization={organization} />
                    </CardBody>
                </Card>
            </Col>
        </Row>
    </Container>
);
export default withRouter(connect((state) => ({
    organization: state.organization
}))(EditBanner));